import styled from 'styled-components';
import { Challenge3dsModalBackdrop } from '../PagarmeChallenge3dsModal/style';

// Above the checkouts' card payment spinner (999999999), which stays up while the payment is ongoing
export const MalgaChallenge3dsModalBackdrop = styled(Challenge3dsModalBackdrop)`
  z-index: 1000000000;
`;
